<template>
  <div class="d-flex justify-content-end">
    <dropdown-menu :items="actions" :select="onActionSelect" class="ml-auto">
      <font-awesome-icon icon="ellipsis-h"
    /></dropdown-menu>
  </div>
</template>

<script>
import get from "lodash/get";
import { INVOICE_ACTIONS, gwtIvoiceActionLabel } from "../../../config/global";

export default {
  name: "MarketInvoicesTableActions",

  computed: {
    INVOICE_ACTIONS_LABEL() {
      return gwtIvoiceActionLabel(this.$i18n);
    },
    actions() {
      const actions = [
        {
          id: INVOICE_ACTIONS.DOWNLOAD_PDF,
          text: this.INVOICE_ACTIONS_LABEL.DOWNLOAD_PDF,
        },
        {
          id: INVOICE_ACTIONS.DOWNLOAD_CSV,
          text: this.INVOICE_ACTIONS_LABEL.DOWNLOAD_CSV,
        },
      ];
      return actions;
    },
  },

  methods: {
    isPaid() {
      return get(this.data, "payed", false); // fixme
    },

    onActionSelect(args) {
      const { id } = args.item;
      const { file_pdf, file_csv } = this.data;

      if (id === INVOICE_ACTIONS.DOWNLOAD_PDF && file_pdf) {
        window.open(file_pdf, "_blank");
      }

      if (id === INVOICE_ACTIONS.DOWNLOAD_CSV && file_csv) {
        window.open(file_csv, "_blank");
      }
    },
  },
};
</script>
